module.exports = __webpack_public_path__ + "img/obch6.fa94ece7.svg";